'use client';
import React, { useState, useEffect } from 'react';
import { Carousel, Container } from 'react-bootstrap';
import Image from 'next/image';
import './productBlog.scss';
import Link from 'next/link';
import { LANDING_OR_PRODUCT_PAGE_QUERY_RESULT } from '@/sanity.types';
import { urlForImage } from '@/sanity/lib/utils';
import Typography from '@/componentv2/typography/typography';

interface ProductBlogSectionProps {
  data: NonNullable<LANDING_OR_PRODUCT_PAGE_QUERY_RESULT>;
}

interface BlogItemProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  blog: any;
  index: number;
}

const BlogItem = ({ blog, index }: BlogItemProps) => {
  return (
    <>
      {blog?.link?.url ? (
        <Link href={blog?.link?.url || '#'}>
          <div className="blog-item">
            {blog?.image && (
              <div className="blog-image">
                <Image
                  src={
                    blog?.image
                      ? (urlForImage(blog?.image)?.url() as string)
                      : ''
                  }
                  alt={`Blog Image ${index + 1}`}
                  width={
                    blog?.image?.imgAsset?.metadata?.dimensions?.width || 350
                  }
                  height={
                    blog?.image?.imgAsset?.metadata?.dimensions?.height || 200
                  }
                  placeholder="blur"
                  blurDataURL={blog?.image?.imgAsset?.metadata?.lqip || ''}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
              </div>
            )}
            {blog?.title && (
              <Typography
                as="h3"
                style="h5"
                className="text-black mb-0 flex-grow-1"
              >
                {blog?.title}
              </Typography>
            )}
          </div>
        </Link>
      ) : (
        <div className="blog-item">
          {blog?.image && (
            <div className="blog-image">
              <Image
                src={urlForImage(blog?.image)?.url() as string}
                alt={`Blog Image ${index + 1}`}
                width={
                  blog?.image?.imgAsset?.metadata?.dimensions?.width || 350
                }
                height={
                  blog?.image?.imgAsset?.metadata?.dimensions?.height || 200
                }
                placeholder="blur"
                blurDataURL={blog?.image?.imgAsset?.metadata?.lqip || ''}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              />
            </div>
          )}
          {blog?.title && (
            <Typography
              as="h3"
              style="h5"
              className="text-black mb-0 flex-grow-1"
            >
              {blog?.title}
            </Typography>
          )}
        </div>
      )}
    </>
  );
};

export default function ProductBlog({ data }: ProductBlogSectionProps) {
  const productContent =
    data?._type === 'productPage' ? data?.resources?.resourcesBlocks : null;

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);
  return (
    <section className="product-blog-section">
      <Container>
        {isMobile ? (
          <Carousel
            indicators={true}
            controls={false}
            interval={3000}
            slide={true}
            fade={false}
            pause="hover"
            className="new-home-carousel"
          >
            {productContent?.map((blog, index) => (
              <Carousel.Item key={index}>
                <BlogItem blog={blog} index={index} />
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <div className="blog-list-desktop">
            {productContent?.map((blog, index) => (
              <div key={index}>
                <BlogItem blog={blog} index={index} />
              </div>
            ))}
          </div>
        )}
      </Container>
    </section>
  );
}
